// extracted by mini-css-extract-plugin
module.exports = {"w1cq22pq":"w1cq22pq"};